import { CategoriesService } from '@/services/api/categories.service';
import { OfficesService } from '@/services/api/franchises.service';
import { effect, Injectable, signal } from '@angular/core';
import { Category } from 'src/app/models/category.model';
import { Franchise } from 'src/app/models/franchise.model';
import { AssemblyCacheService } from 'src/app/services/app/assembly-cache.service';
// import { CatalogService } from 'src/app/services/app/catalog.service';
// import { CategoriesService } from 'src/app/services/app/categories.service';
// import { OfficesService } from 'src/app/services/global/offices.service';

@Injectable({
  providedIn: 'root'
})
export class AssemblyFilterService {

  constructor(
    private officeService: OfficesService, 
    private categoriesService: CategoriesService,
    private assemblyCacheService: AssemblyCacheService
  ) { 
    
    effect(() => {
      const selectedOffice = this.officeService.selectedOffice();
      if(selectedOffice) {
        this.selectOffice(selectedOffice);
      }
      const selectedCategory = this.categoriesService.selectedCategory();
      // console.log('assembly filters:', selectedCategory, selectedOffice);
      if(selectedCategory && selectedOffice) {
        const offices = this.decideOffice(selectedOffice);
        console.log('filtering office assemblies for FID:', offices.S, offices.O);
        this.assemblyCacheService.filterAssemblies(selectedCategory.CategoryID, offices.S, offices.O);
      }
    });
  }

  selectCategory(id: number) {
    this.categoriesService.setSelectedCategoryById(id);
  }

  decideOffice(office: Franchise) {
    let offices = {
      O: office.Options_FID || office.FID,
      S: office.Standards_FID || office.FID
    }
    return offices;
  }

  selectOffice(office: Franchise) {
      console.log('assembly filter service triggered:', office);
      const offices = this.decideOffice(office);
      this.assemblyCacheService.fetchAssembliesByFid(offices.S,offices.O);
  }

  selectTypes(type: string) {
    const selectedCategory = this.categoriesService.selectedCategory();
    const selectedOffice = this.officeService.selectedOffice();
    if(selectedCategory && selectedOffice) {
      const offices = this.decideOffice(selectedOffice);
      if(type.length > 0) {
        console.log('types selected, filtering assemblies for FID:', offices.S, offices.O, type);
        this.assemblyCacheService.filterAssemblies(selectedCategory.CategoryID, offices.S, offices.O, [type]);
      } else {
        console.log('no types selected, filtering assemblies for FID:', offices.S, offices.O);
        this.assemblyCacheService.filterAssemblies(selectedCategory.CategoryID,offices.S, offices.O);
      }
    }
  }
}
